(() => {
  if (window.vmDetailFacetUI) { window.vmDetailFacetUI.scan(document); return; }
  const bound = new Map();
  let instance = 0;
  const facets = toolbar => [...toolbar.querySelectorAll('details.vm-detail-facet')];
  const sync = detail => detail.querySelector('summary')?.setAttribute('aria-expanded', String(detail.open));
  const close = (detail, restoreFocus = false) => {
    detail.open = false;
    sync(detail);
    if (restoreFocus) detail.querySelector('summary')?.focus();
  };
  const closeExcept = keep => bound.forEach((controller, toolbar) => facets(toolbar).forEach(detail => {
    if (detail !== keep && detail.open) close(detail);
  }));
  const bind = toolbar => {
    if (bound.has(toolbar)) return;
    const controller = new AbortController();
    const options = {signal: controller.signal};
    bound.set(toolbar, controller);
    facets(toolbar).forEach(detail => {
      const menu = detail.querySelector('.vm-detail-facet__menu');
      if (menu) {
        menu.id = 'vm-detail-menu-' + (++instance);
        detail.querySelector('summary').setAttribute('aria-controls', menu.id);
      }
      sync(detail);
    });
    toolbar.addEventListener('change', event => {
      if (!event.target.matches('input[type="checkbox"]')) return;
      const form = document.getElementById(toolbar.dataset.formId);
      // Preserve Turbo's existing immediate checkbox GET submission.
      if (form) form.dispatchEvent(new Event('change', {bubbles: true}));
    }, options);
    toolbar.addEventListener('change', event => {
      if (!event.target.matches('[data-sort-by]')) return;
      event.stopImmediatePropagation();
      const query = new URLSearchParams(location.search);
      query.set('sort_by', event.target.value);
      query.delete('page');
      location.search = query.toString();
    }, {capture: true, signal: controller.signal});
    toolbar.addEventListener('toggle', event => {
      const detail = event.target;
      if (!detail.matches('details.vm-detail-facet')) return;
      if (detail.open) closeExcept(detail);
      sync(detail);
    }, {capture: true, signal: controller.signal});
    toolbar.addEventListener('click', event => {
      const detail = event.target.closest('button[type="submit"]')?.closest('details.vm-detail-facet');
      if (detail) close(detail);
    }, options);
  };
  const cleanup = () => bound.forEach((controller, toolbar) => {
    if (!toolbar.isConnected) { controller.abort(); bound.delete(toolbar); }
  });
  const scan = root => {
    if (root.matches?.('[data-vm-detail-toolbar]')) bind(root);
    root.querySelectorAll?.('[data-vm-detail-toolbar]').forEach(bind);
    cleanup();
  };
  document.addEventListener('click', event => closeExcept(event.target.closest?.('details.vm-detail-facet')), true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    bound.forEach((controller, toolbar) => facets(toolbar).forEach(detail => {
      if (!detail.open) return;
      event.preventDefault();
      close(detail, detail.contains(document.activeElement));
    }));
  });
  const observer = new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); }));
    cleanup();
  });
  observer.observe(document.documentElement, {childList: true, subtree: true});
  window.vmDetailFacetUI = {scan};
  scan(document);
})();
